import {currentPeriod} from '@/helpers/date'

export default {
  async FETCH_ALL ({ commit, dispatch }, { loading = true, notify = {} }) {
    if (loading) commit('SET_APP_LOADING', true)
    await dispatch('FETCH_USER')
    await dispatch('FETCH_DREAMS')
    // await dispatch('FETCH_TIPS')
    if (loading) commit('SET_APP_LOADING', false)
    await dispatch('UPDATE_USER_VISIT', { notify })
  },
  SET_CURRENT_PERIOD ({ commit }, currentPeriod) {
    commit('SET_CURRENT_PERIOD', currentPeriod)
  },
  RESET_CURRENT_PERIOD ({ dispatch }) {
    dispatch('SET_CURRENT_PERIOD', currentPeriod())
  },
  PLAY_SOUND_EFFECT ({ commit }, sound) {
    commit('SET_SOUND_EFFECT', { sound, timestamp: new Date() })
  },
  FETCH_STATS ({ commit }, sound) {

  },
}
